import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import './MapInfo.scss'

@observer
class MapInfo extends Component {
  render() {
    return (
      <div className="map-info">
        <div className="phones">
          <ul className="operators">
            <li className="operators-item">
              <a className="operators-link" href="tel:+380502488248" id="order-module-tel-mts">
                <i className="icons">M</i>
              </a>
            </li>
            <li className="operators-item">
              <a className="operators-link" href="tel:+380972488248" id="order-module-tel-kyivstar">
                <i className="icons">K</i>
              </a>
            </li>
            <li className="operators-item">
              <a className="operators-link" href="tel:+380932488248" id="order-module-tel-life">
                <i className="icons">L</i>
              </a>
            </li>
            <li className="operators-item">
              <a className="operators-link" href="tel:+380912488248" id="order-module-tel-3mob">
                <i className="icons">J</i>
              </a>
            </li>
          </ul>
          <div className="operators-item">
            <a className="operators-link phone-number" href="tel:+380442488248" id="order-module-tel-stationary">+38 (044) 248-8-248</a>
          </div>
        </div>
        <div className="car-status-block">
          <ul className="car-categories">
            <li className="car-category car-category--all" id="all" onClick={() => this.props.filterCars(null)}> Все </li>
            <li className="car-category car-category--standart" id="standart" onClick={() => this.props.filterCars(2)}> Стандарт </li>
            <li className="car-category car-category--bussines" id="biznes" onClick={() => this.props.filterCars(6)}> Бизнес </li>
            <li className="car-category car-category--premium" id="premium" onClick={() => this.props.filterCars(1)}> Премиум </li>
            <li className="car-category car-category--busy" id="busy" onClick={() => this.props.filterCars(3)}> Занят </li>
          </ul>
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  filterCars: stores.MapStore.filterCars,
}))

export default withData(MapInfo);
